import { createElement } from "react";
import { useSession, type AskSlotProps, type Entrypoint, type Slots } from "../client/index.ts";
import { suspended } from "../client/entrypoint.ts";
import { contributions } from "./entrypoints.generated.ts";

export const entrypoints: readonly Entrypoint[] = contributions.flat();

const conversationParts = suspended(() => import("./conversation/index.ts"));

function Answers() {
  const session = useSession();
  return session.status === "dentro" && session.view.derived.modules.conversas
    ? createElement(conversationParts().Answers) : null;
}

function Sidebar() {
  const session = useSession();
  return session.status === "dentro" && session.view.derived.modules.conversas
    ? createElement(conversationParts().Conversas, { heading: false }) : null;
}

export const slots: Slots = {
  answers: Answers,
  sidebar: Sidebar,
  ask: (props: AskSlotProps) => createElement(conversationParts().AskArea, props),
};
